import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getMuiTheme } from '../../muiTheme';
import { useTheme as useAppTheme } from '../../context/ThemeContext';

const MuiAppProvider = ({ children }) => {
  const { theme } = useAppTheme();
  return (
    <MuiThemeProvider theme={getMuiTheme(theme === 'dark' ? 'dark' : 'light')}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default MuiAppProvider;
